import React from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import {
  areEqual,
  getVarsoUrl,
  renderSingleWithLabel,
} from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import withErrorGuard from "../../../../HOC/withErrorGuard";

const { arrayOf, number, shape, string } = PropTypes;

const CGD = ({ data }) => {
  if (data && Object.keys(data || {}).length > 0) {
    return (
      <div className="varsome-result-fixed">
        <div
          className="varsome-container varsome-container__basic"
          data-testid="cgd-component"
        >
          <ComponentPanel
            title=" Clinical Genomic Database (CGD)"
            version={data?.version}
            url={getVarsoUrl("http://research.nhgri.nih.gov/CGD/")}
            content={
              <div className="varsome-inner-container">
                <div className="varsome-horiz-flex">
                  {renderSingleWithLabel(data, "age_group", "Age group")}
                  {renderSingleWithLabel(data, "condition", "Condition")}
                  {renderSingleWithLabel(data, "inheritance", "Inheritance")}
                  <div className="varsome-horiz-list-item">
                    <div className="varsome-horiz-list-label">
                      Intervention categories
                    </div>
                    {data.intervention_categories.map((item, i, arr) => {
                      return (
                        <span key={i}>
                          {item}
                          {i < arr.length - 1 ? ", " : ""}
                        </span>
                      );
                    })}
                  </div>
                  {data.pub_med_references && (
                    <div className="varsome-horiz-list-item">
                      <div className="varsome-horiz-list-label">
                        Publications
                      </div>
                      <div className="varsome-horiz-list-value">
                        {data.pub_med_references.length > 0 ? (
                          <PublicationLinks
                            limit={10}
                            ids={data.pub_med_references}
                          />
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  )}
                  <div className="varsome-clearfix tw-w-full">
                    <small className="varsome-right">
                      Courtesy of:
                      <a
                        href={getVarsoUrl("https://www.genome.gov/")}
                        target="_blank"
                      >
                        {" National Human Genome Research Institute"}
                      </a>
                    </small>
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
  return null;
};

CGD.propTypes = {
  data: shape({
    age_group: string,
    comments: string,
    condition: string,
    inheritance: string,
    intervention: arrayOf(string),
    intervention_categories: arrayOf(string),
    pub_med_references: arrayOf(number),
    version: string,
  }),
};

CGD.defaultProps = {
  data: null,
};

export default withErrorGuard(
  React.memo(CGD, areEqual),
  "CGD",
  "Clinical Genomic Database (CGD)"
);
